import React from 'react';

const FilterPanel = ({
  isFilterExpanded,
  setIsFilterExpanded,
  filterCategory,
  setFilterCategory,
  filterType,
  setFilterType,
  filterCounty,
  setFilterCounty,
  filterStatus,
  setFilterStatus,
  filterIsAdminOnly,
  setFilterIsAdminOnly,
  isRefreshing,
  handleRefresh,
  handleApplyFilters,
  handleClearFilters,
  categories,
  filterTypes,
  counties,
  isAdmin,
  styles
}) => {
  return (
    <div style={styles.filterContainer}>
      <div 
        style={styles.filterHeader}
        onClick={() => setIsFilterExpanded(!isFilterExpanded)}
      >
        <h3 style={styles.sectionTitle}>Add Filters</h3>
        <span
          style={{
            ...styles.expandArrow,
            transform: isFilterExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            marginRight: '10px'
          }}
        >
          ▼
        </span>
      </div>

      {isFilterExpanded && (
        <div style={styles.filterControls}>
          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Category:</label>
            <select
              value={filterCategory}
              onChange={(e) => {
                setFilterCategory(e.target.value);
                setFilterType('');
              }}
              style={styles.filterSelect}
            >
              <option value="">All</option>
              {categories.map(c => (
                <option key={c.ID} value={c.ID}>{c.Name}</option>
              ))}
            </select>
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Type:</label>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="">All</option>
              {filterTypes.map(t => (
                <option key={t.ID} value={t.ID}>{t.Name}</option>
              ))}
            </select>
          </div>

          {isAdmin && (
            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>County:</label>
              <select
                value={filterCounty}
                onChange={(e) => setFilterCounty(e.target.value)}
                style={styles.filterSelect}
              >
                <option value="">All</option>
                {counties.map(c => (
                  <option key={c.CountyID} value={c.CountyID}>{c.Name}</option>
                ))}
              </select>
            </div>
          )}

          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Status:</label>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="">All</option>
              <option value="1">New</option>
              <option value="2">Completed</option>
              <option value="3">In progress</option>
              <option value="4">Needs More Info</option>
            </select>
          </div>

          {isAdmin && (
            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>Access:</label>
              <select
                value={filterIsAdminOnly}
                onChange={(e) => setFilterIsAdminOnly(e.target.value)}
                style={styles.filterSelect}
              >
                <option value="">All</option>
                <option value="0">Client</option>
                <option value="1">Internal</option>
              </select>
            </div>
          )}

          <div style={styles.filterGroup}>
            <button onClick={handleRefresh} style={styles.filterRefresh} disabled={isRefreshing}>
              {isRefreshing ? '⟳ Refreshing...' : '⟳'}
            </button>
          </div>

          <div style={styles.filterActions}>
            <button onClick={() => handleApplyFilters(1, { resetPage: true })} style={styles.applyButton}>Apply</button>
            <button onClick={handleClearFilters} style={styles.clearButton}>Clear</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
